import React, { useCallback, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { AuthenticationRoutes, AdminProtectedRoute, PrivateRoutes, MerchantProtectedRoutes } from '../../Routes/Index';
import {
    DashBoard,
    DashBoardHome,
    ImagesLibrary,
    Header,
    NewOrder,
    ManageOrder,
    ProductLibrary,
    StockAvaibility,
    Settings,
    AddProduct,
    ManageOrderMerch,
    Signin,
    ForgotPass,
    Signup,
    Product,
    ProductViewAll,
    AccessManagement,
    ManageMerchants,
    Billing,
    Testing,
} from '..';
import { useUser } from '../../Context/User';

import './style.css';
const Index = () => {
    const [sidebar, showSidebar] = useState(false);
    const { role } = useUser();

    const toggleSideBar = useCallback(() => {
        showSidebar((prev) => !prev);
    }, []);
    return (
        <main className="container">
            <Switch>
                <AuthenticationRoutes fallback="/main" path="/" exact>
                    <Signin />
                </AuthenticationRoutes>
                <AuthenticationRoutes fallback="/main" path="/forgotPassword" exact>
                    <ForgotPass />
                </AuthenticationRoutes>
                <AuthenticationRoutes fallback="/main" path="/signup" exact>
                    <Signup />
                </AuthenticationRoutes>
                <Route path="/main">
                    <DashBoard toggleShow={toggleSideBar} show={sidebar} />
                    <div className="viewport">
                        <Header sidebar={sidebar} setSidebar={toggleSideBar} />
                        <Switch>
                            <Route path="/main/test" exact>
                                <Testing />
                            </Route>
                            <PrivateRoutes fallback="/" path="/main" exact>
                                <DashBoardHome type={role} />
                            </PrivateRoutes>
                            <PrivateRoutes fallback="/" path="/main/imageLibrary" exact>
                                <ImagesLibrary />
                            </PrivateRoutes>
                            <PrivateRoutes fallback="/" path="/main/newOrder" exact>
                                <NewOrder />
                            </PrivateRoutes>
                            <PrivateRoutes fallback="/" path="/main/viewall/:type" exact>
                                <ProductViewAll />
                            </PrivateRoutes>
                            <PrivateRoutes fallback="/" path="/main/manageOrders">
                                <ManageOrder />
                            </PrivateRoutes>
                            <MerchantProtectedRoutes fallback="/" path="/main/settings">
                                <Settings />
                            </MerchantProtectedRoutes>
                            <PrivateRoutes fallback="/" path="/main/billing">
                                <Billing />
                            </PrivateRoutes>
                            <AdminProtectedRoute fallback="/" path="/main/ProductLibrary" exact>
                                <ProductLibrary />
                            </AdminProtectedRoute>
                            <AdminProtectedRoute fallback="/" path="/main/addProduct" exact>
                                <AddProduct />
                            </AdminProtectedRoute>
                            <AdminProtectedRoute fallback="/" path="/main/manageMerchants" exact>
                                <ManageMerchants />
                            </AdminProtectedRoute>
                            {/* <MerchantProtectedRoutes fallback="/" path="/main/stockAvaibility" exact>
                                <StockAvaibility />
                            </MerchantProtectedRoutes> */}
                            <AdminProtectedRoute fallback="/" path="/main/accessManagement" exact>
                                <AccessManagement />
                            </AdminProtectedRoute>
                            <AdminProtectedRoute fallback="/" path="/main/orders" exact>
                                <ManageOrderMerch />
                            </AdminProtectedRoute>
                            {/* <PrivateRoutes fallback="/" path="/main/product/:id" exact>
                                <Product />
                            </PrivateRoutes> */}
                            <Redirect to="/main" exact />
                        </Switch>
                    </div>
                </Route>
                <Redirect to="/" exact />
            </Switch>
        </main>
    );
};

export default Index;
